import api from './AxiosService';

const CouponService = {
  getAllCoupons: () => api.get('/coupons'),
  addCoupon: (data) => api.post('/coupons/add', data),
  toggleStatus: (id) => api.put(`/coupons/status/${id}`),
  deleteCoupon: (id) => api.delete(`/coupons/${id}`),
};

export default CouponService;
